'use client';

import {useTranslations} from 'next-intl';

const partners = [
  {name: 'Ministère des Affaires Sociales', initials: 'MAS'},
  {name: 'UNICEF', initials: 'UNICEF'},
  {name: 'Croissant-Rouge Tunisien', initials: 'CRT'},
  {name: 'Programme Alimentaire Mondial', initials: 'PAM'},
];

export default function PartnersSection({showTitle = true}: {showTitle?: boolean}) {
  const t = useTranslations('partners');
  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {showTitle && (
          <h2 className="text-2xl sm:text-3xl font-bold text-primary text-center mb-10">
            {t('title')}
          </h2>
        )}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {partners.map(({name, initials}) => (
            <div
              key={name}
              className="flex flex-col items-center justify-center p-6 rounded-xl border border-border bg-surface hover:shadow-md transition-shadow"
            >
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-3">
                <span className="text-primary font-bold text-sm">{initials}</span>
              </div>
              <p className="text-foreground text-sm font-medium text-center leading-tight">{name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
